<div class="card mb-3">
  <div class="row" [ngClass]="{'card-body': quill == true}">
    <img class="col-12 rounded img-fluid" [ngClass]="{'mb-4': quill == true}" src="{{custwelcome?.medialink}}">
    <div class="col-12" *ngIf="quill == true">
      <quill-view-html class="text-dark quill-top-pad" [content]="custwelcome?.markup" theme="snow"></quill-view-html>
    </div>
  </div>
</div>